export * from './details.component';
export * from './details.helper';
export * from './details-update.model';
export * from './details.type';
